import React from "react";
import AllInventoryOverride from "./InventoryModule/AllInventoryOverride";

const InventoryOverride = () => {
  return (
    <div>
      <AllInventoryOverride />
    </div>
  );
};

export default InventoryOverride;
